import React, { FC } from 'react';
import { Box } from '@mui/material';
import { labDirectoryTemplate } from 'apollo/templates/lab-directory';
import OpeningHours from 'components/connect-to-lab/lab-details-dialog/opening-hours.component';
import { DirectoryBrowserConfig } from 'components/supplier-browser/directory-browser-config';
import DirectoryBrowser from 'components/supplier-browser/directory-browser.component';
import { LAB_CONSTRUCTIONS, LabDirectoryLab } from 'models/lab-directory';
import ConnectLabAction from './connect-lab-action.component';

const constructionLabelKey = (construction: string) => `lab-settings:${construction.toUpperCase()}`;

const LAB_BROWSER_CONFIG: DirectoryBrowserConfig = {
    query: labDirectoryTemplate,
    field: 'labDirectory',
    // The pills are the constructions a lab offers clinics; several = any of them.
    services: LAB_CONSTRUCTIONS,
    serviceLabelKey: constructionLabelKey,
    texts: {
        noneListed: 'client-directory:NO_LABS_LISTED',
        noneMatch: 'client-directory:NO_LABS_MATCH',
        hideConnected: 'client-directory:HIDE_CONNECTED_LABS',
        mapTitle: 'client-directory:LAB_MAP_TITLE',
        mapOnlyLocated: 'client-directory:LAB_MAP_ONLY_LOCATED',
        noDescription: 'client-directory:SUPPLIER_NO_DESCRIPTION',
    },
    renderAction: (lab) => <ConnectLabAction lab={lab} />,
    // The directory lists labDirectory's labs, so each carries its opening hours.
    renderDetails: (lab) => {
        const { openingHours } = lab as LabDirectoryLab;
        return openingHours?.length ? (
            <Box mt={2}>
                <OpeningHours currentLab={{ openingHours }} />
            </Box>
        ) : undefined;
    },
};

/**
 * DD-3696 "Find lab": Pro dentists find labs the way labs find suppliers (DD-3662) — the
 * same cards, filters, map and profile — and connect to one at once.
 */
const LabBrowser: FC = () => <DirectoryBrowser config={LAB_BROWSER_CONFIG} />;

export default LabBrowser;
